import React, { ReactElement } from "react"
import SiteHeader from "../components/common/SiteHeader"
import SiteFooter from "../components/common/SiteFooter"
import SEO from "../components/common/SEO"

export interface IMainPageProps {
  seoProps?: any
  headerProps?: any
  footerProps?: any
  className?: string
  children?: ReactElement
}

export const MainPage: React.FC<IMainPageProps> = ({
  seoProps,
  headerProps,
  footerProps,
  children,
  className = "",
}) => {
  const siteWrapper = (
    <div
      id="site-wrapper"
      className={`flex flex-col min-h-screen ${className}`}
    >
      <SiteHeader
        languageCode="en-us"
        isMultiLanguage={false}
        {...headerProps}
      />
      <main className={`flex-grow`}>{children}</main>
      <SiteFooter {...footerProps} />
    </div>
  )

  return (
    <>
      <SEO {...seoProps} />
      {siteWrapper}
    </>
  )
}

export default MainPage
